import { ThemeColor } from 'ui/styles/types';

export interface SidebarTheme {
  width: number; // px
  small: number; // px
  color: ThemeColor;
  padding: number;
  paddingSmall: number;
}

export default {
  width: 230,
  small: 214,
  color: ({ theme }: any) => theme.colorVariants.background,
  padding: 32,
  paddingSmall: 24,
} as SidebarTheme;
